
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_12185_272494)","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.723 14.01h-3a.5.5 0 01-.5-.5v-2.793a.5.5 0 01.146-.353l7.5-7.5a.5.5 0 01.707 0l2.793 2.793a.5.5 0 010 .707L6.723 14.01zM9.223 4.509l3.5 3.5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_12185_272494"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.723 .509)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    